import type { ResourceConfig } from "../types";

export const praiseConfig = {
  displayName: "好评",
  category: "praise",
  permissions: {
    "read:all": {
      label: "查看所有好评",
      description: "可以查看系统中所有好评记录",
    },
    "write:all": {
      label: "录入好评",
      description: "可以录入新的好评记录",
    },
    "read:assigned": {
      label: "查看自己录入的好评",
      description: "只能查看自己录入的好评记录",
    },
    "write:assigned": {
      label: "编辑自己录入的好评",
      description: "只能编辑自己录入的好评记录",
    },
    "review:all": {
      label: "审核好评",
      description: "可以审核所有好评（通过/拒绝）",
    },
    "moment:all": {
      label: "标记朋友圈发布",
      description: "可以标记好评已发布到朋友圈",
    },
  },
  scopeStrategy: "byInteractionStaff",
  // 导航入口在交付管理 Tab 中，不在主导航
  // navigation: undefined
} satisfies ResourceConfig;
